export const formatAge = (age) => {
    const arr = age.split('_')
    if (arr[2] >= 90) {
        return `>=${arr[1]}`
    }
    return `${arr[1]}-${arr[2]}`
}
